import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import queryBannerImage from "../../hooks/query-banner-image"
import useMinimalConfig from "../../hooks/use-minimal-config"
import useSiteMetadata from "../../hooks/use-site-metadata"
import replaceSlashes from "../../../utils/replace-slashes"
import { withCurrentCopyrightYear } from "../../../utils/copyright-year"
import { FooterType } from "../../types"
import { isDesktopScreen } from "../../../utils/measure-screen-size"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterModern = ({ footer, ...props }: LayoutProps) => {
  const { footerNavigation: nav, basePath } = useMinimalConfig()
  const { siteImage, siteTitle, footerCopyrightText } = useSiteMetadata()
  const logoImage = queryBannerImage(footer?.logo || siteImage)
  const [height, setHeight] = useState(18)
  const logoImageAspectRatio = logoImage ? logoImage?.node?.gatsbyImageData.width / logoImage?.node?.gatsbyImageData.height : 1

  useEffect(() => {
    setHeight(isDesktopScreen() ? 36 : 18)
  })

  return (
    <footer className={`${footer.advanced?.class || ``} mb-6`} style={{ background: `#171717` }}>
      <div style={{ background: `#2D2D2D` }}>
        <div className="container flex items-left justify-between">
            <div className="mt-4 flex md:justify-center space-x-6 md:order-2 my-4">
            {nav &&
                nav.map((item: any, itemIndex: any) => (
                <Link key={item.slug} className="text-footerColor text-xs font-semibold md:text-sm" to={replaceSlashes(`/${basePath}/${item.slug}`)}>
                    {item.title}
                </Link>
                ))}
            </div>
        </div>
      </div>

      {footerCopyrightText && <div className="container pt-4 pb-14 text-center md:text-left text-sm" style={{ color: `#999` }}>{withCurrentCopyrightYear(`${footerCopyrightText}`)}</div>}
    </footer>
  )
}

export default FooterModern
